/* eslint-disable @typescript-eslint/naming-convention */
export enum DeleteWarningMessages {
  partner = "Deleting this partner will also delete every associated companies, assets, contracts, locations, sales representatives and users.",
  company = "Deleting this company will also delete every associated assets, contracts, locations, and users.",
  contract = "Deleting this contract will also delete every associated assets.",
  asset = "Only global admin can delete assets that are assigned to a staff managed contract.",
  location = "This location will not be deleted if it is assigned to an asset. \n All linked users will be unlinked if you delete this location.",
  maintenanceProvider = "This maintenance provider will not be deleted if it is associated to a contract.",
  "asset-quote" = "Only global admin can delete assets that are assigned to a staff managed quote.",
  internalProvider = "This internal provider will not be deleted if it is associated to an asset.",
}
